function initOrdering() {
	// Режим розницы
	if (document.querySelector('.ordering-page')) {
		let closestElem = document.querySelector('.header__block-info')
		let list = closestElem.querySelector('.mg-avatar__list')
		let itemWrapp = list.querySelector('.checkbox-on-off')
		let itemCheckbox = list.querySelector('.mg-checkbox__input')
		if (itemCheckbox.getAttribute('data-on-off') === 'true') {
			itemCheckbox.checked = true
		} else {
			itemCheckbox.checked = false
		}
		itemWrapp.addEventListener('click', () => {
			if (itemCheckbox.getAttribute('data-on-off') === 'true') {
				itemCheckbox.setAttribute('data-on-off', 'false')
			} else {
				itemCheckbox.setAttribute('data-on-off', 'true')
			}
		})

		const switchClass = (elem, [...classesName], add) => {
			let remClass = classesName[0]
			let addClass = classesName[1]
			if (add) {
				elem.classList.remove(remClass)
				elem.classList.add(addClass)
			} else {
				elem.classList.add(remClass)
				elem.classList.remove(addClass)
			}
		}

		const validCheck = (selectedItem, validClass, invalidClass) => {
			if (!selectedItem) return false

			if (
				selectedItem.querySelector('.payment') ||
				selectedItem.querySelector('.delivery')
			) {
				switchClass(
					selectedItem,
					[
						'ordering-page__list-item--error',
						'ordering-page__list-item--success',
					],
					false
				)
				return false
			}

			let inputs
			selectedItem.querySelector('input')
				? (inputs = selectedItem.querySelectorAll('input'))
				: (inputs = selectedItem.querySelectorAll('textarea'))

			const check = () => {
				selectedItem.querySelectorAll('.valid-inp').length === inputs.length
					? switchClass(
							selectedItem,
							[
								'ordering-page__list-item--error',
								'ordering-page__list-item--success',
							],
							true
					  )
					: switchClass(
							selectedItem,
							[
								'ordering-page__list-item--error',
								'ordering-page__list-item--success',
							],
							false
					  )
			}

			const checkStatusField = inp => {
				if (inp.value || inp.checked) {
					inp.classList.add(validClass)
					inp.classList.remove(invalidClass)
				} else {
					inp.classList.remove(validClass)
					inp.classList.add(invalidClass)
				}
			}

			check()

			inputs.forEach(inp => {
				checkStatusField(inp)
				check()
				inp.oninput = inp.onchange = () => {
					checkStatusField(inp)
					check()
				}
			})
		}

		// quiz-items
		let orderingPageList = document.querySelector('.ordering-page__list')
		if (orderingPageList !== null) {
			let orderingPageItem = orderingPageList.querySelectorAll(
				'.ordering-page__list-item'
			)

			orderingPageItem.forEach(item => {
				item.classList.remove('ordering-page__list-item--disable')
				validCheck(item, 'valid-inp', 'invalid-inp')
				item.onclick = () => {
					item.classList.remove('ordering-page__list-item--disable')
					validCheck(item, 'valid-inp', 'invalid-inp')
				}
			})
		}
	}
}

if (document.querySelector('[data-on-off]')) {
	let check = document.querySelector('[data-on-off]')
	if (check.getAttribute('data-on-off') === 'true') {
		check.checked = true
	} else {
		check.checked = false
	}
}
